<template>
  <!-- Selector de modo -->
  <div v-if="!modo" class="formulario-modelo">
    <h1>Proceso de Autoevaluación</h1>
    <p class="subtitulo">Selecciona el modo con el que deseas ingresar</p>

    <div class="divider"></div>

    <div class="selector-cards">
      <button
        v-if="store.tienePermiso('procesos.crear') || store.tienePermiso('procesos.asignar')"
        class="modo-card"
        @click="modo = 'admin'"
      >
        <span class="modo-nombre">Administrador</span>
        <span class="modo-desc">Crear y gestionar procesos de autoevaluación</span>
      </button>
      <button
        v-if="store.tienePermiso('calificacion.calificar') || store.tienePermiso('calificacion.ver')"
        class="modo-card"
        @click="modo = 'usuario'"
      >
        <span class="modo-nombre">Usuario</span>
        <span class="modo-desc">Ver y completar las evaluaciones asignadas</span>
      </button>
    </div>
  </div>

  <!-- Vista según modo — cada hijo tiene su propio contenedor -->
  <ProcesoAdminView  v-else-if="modo === 'admin'"   @cambiar-modo="modo = null" />
  <ProcesoUsuarioView v-else-if="modo === 'usuario'" @cambiar-modo="modo = null" />
</template>

<script lang="ts" setup>
/**
 * Administración de ejecuciones de modelo.
 *
 * Es la pantalla donde entra el ÁREA evaluada: `ambito` e `id_programa` son
 * columnas de la ejecución y de ninguna otra entidad.
 *
 * ── Enrutado ─────────────────────────────────────────────────────
 *   `/procesos-autoevaluacion` (ProcesoAutoevaluacion) — permiso `procesos.ver`
 *
 * Vista enrutada. Obtiene sus datos a través de stores Pinia: no llama a `http`
 * ni a los servicios directamente.
 */

import { ref } from 'vue'
import { useRoute } from 'vue-router'
import ProcesoAdminView   from '@/views/ProcesoAutoevaluacionAdminView.vue'
import ProcesoUsuarioView from '@/views/ProcesoAutoevaluacionUsuarioView.vue'
import useAutenticar from '@/store/IngresoAutenticar'

const route = useRoute()
const store = useAutenticar()

const modoInicial = route.query.modo === 'admin' ? 'admin'
  : route.query.modo === 'usuario' ? 'usuario'
  : null
const modo = ref<'admin' | 'usuario' | null>(modoInicial)
</script>

<style scoped>
.formulario-modelo {
  background-color: white;
  padding: var(--space-lg);
  border-radius: var(--radius-lg);
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  box-shadow: var(--shadow-md);
  box-sizing: border-box;
  margin: 20px;
  font-family: var(--font-family);
}

h1 {
  font-size: var(--font-size-2xl, 1.5rem);
  font-weight: 700;
  color: #1a1a1a;
  margin: 0 0 0.25rem 0;
  letter-spacing: 0.01em;
}

.subtitulo {
  font-size: var(--font-size-sm, 0.875rem);
  color: #555;
  margin: 0;
}

.divider {
  border: none;
  border-bottom: 1px solid #e0e0e0;
  margin: 1rem 0 1.5rem;
}

.selector-cards {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
}

.modo-card {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.35rem;
  width: 220px;
  padding: 1.25rem 1.5rem;
  background: white;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 12px;
  cursor: pointer;
  font-family: var(--font-family);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06), 0 1px 2px rgba(0, 0, 0, 0.04);
  transition: box-shadow 0.2s ease, transform 0.2s ease, border-color 0.2s;
  text-align: left;
}

.modo-card:hover {
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.07), 0 2px 4px rgba(0, 0, 0, 0.04);
  transform: translateY(-2px);
  border-color: #0e69a0;
}

.modo-nombre {
  font-size: 1rem;
  font-weight: 700;
  color: #1a1a1a;
}

.modo-desc {
  font-size: 0.82rem;
  color: #555;
  line-height: 1.4;
}
</style>
